// extracted by mini-css-extract-plugin
module.exports = {"card":"InfoCard_card__3_FdO","titleContainer":"InfoCard_titleContainer__1DkOK","icon":"InfoCard_icon__1ZHDW","title":"InfoCard_title__38lq7"};